import React from "react";
import { useCurrentAccountQuery } from "../../../../../api/queries/useAccountQuery";
import { WORKSPACE_STATUS } from "../../../../../consts/api";
import { lockAppUntilAccountAddressUpdated } from "../../../../../utilities/localStorage";

export const AccountOnHoldModal = () => {
  const [showHoldModal, setShowHoldModal] = React.useState(false);
  const closedByUserRef = React.useRef(false);
  const { data: account } = useCurrentAccountQuery();

  const onClose = () => {
    closedByUserRef.current = true;
    setShowHoldModal(false);
  };

  React.useEffect(() => {
    if (
      [WORKSPACE_STATUS.hold, WORKSPACE_STATUS.cancelled].includes(
        account?.globalSettings?.accountStatus,
      ) &&
      !lockAppUntilAccountAddressUpdated.get() &&
      !closedByUserRef.current
    ) {
      setShowHoldModal(true);
    }
  }, [
    account?.globalSettings?.accountStatus,
    closedByUserRef.current,
    lockAppUntilAccountAddressUpdated.get(),
  ]);

  return (
    <>
      {showHoldModal && (
        <div>
          <div className="modalOverlay">
            <div className="small-popup-outer">
              <div className="small-popup-header p-l-15">
                <div className="popup-name">Account On Hold!</div>
                <button className="small-cross" onClick={onClose}>
                  ×
                </button>
              </div>
              <div className="small-popup-content">
                <div className="juvly-container">
                  Your account is on hold. Please note that once your payment
                  method is updated, your account will be automatically charged
                  for any outstanding or upcoming subscription fees. This
                  ensures uninterrupted access to your services.
                </div>
                <button
                  type="button"
                  className="new-blue-btn pull-right m-b-10 m-r-10"
                  onClick={onClose}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
